import { Movax } from './Movax';

// jquery does not currently support es6 way of importing so we need to do it old school
var $ = require('jquery');

/**
 * create Questionnaire
 * @class
 */
class Questionnaire {
  private jsBlock: string;
  private dom = {
    $el: null,
    $makeSelect: null,
    $excavatorSelectHolder: null,
    $excavatorSelect: null,
  };
  private excavatorsData;
  private excavatorClasses;
  private productData;
  private validator;
  private listTemplate;
  private searchGroups;

  constructor(private id: string, private block: string) {
    this.jsBlock = 'js-' + block;
    this.dom.$el = $('#' + id);
  }

  private _getMakeData(makeUuid) {
    var i, l;

    for (i = 0, l = this.excavatorsData.length; i < l; i++ ) {
      if (this.excavatorsData[i].uuid === makeUuid) {
        return this.excavatorsData[i];
      }
    }

    return null;
  }

  private _updateExcavatorSelectHTML(models, targetSelect) {
    var html = '',
        i, l;

    html += '<option value="">' + this.dom.$excavatorSelect.data('empty-option-text') + '</option>';
    for (i = 0, l = models.length; i < l; i++) {
      html += '<option value="' + models[i].model + '">' + models[i].model + '</option>';
    }
    this.dom.$excavatorSelect.filter(targetSelect).html(html);
    this.dom.$excavatorSelect.filter(targetSelect).trigger('change');
    console.log(this.dom.$excavatorSelect.filter(targetSelect));
  }

  private _updateExcavatorSelect(makeUuid:string, targetSelect:string) {
    var makeData = this._getMakeData(makeUuid),
        models = makeData && makeData.models || [];

    if(models.length) {
      this._updateExcavatorSelectHTML(models, targetSelect);
      //this.dom.$excavatorSelectHolder.show(200);
    } else {
      //this.dom.$excavatorSelectHolder.hide(200);
    }
  }

  private _initExcavatorSelect() {
    var self = this;

    this.dom.$excavatorSelectHolder = this.dom.$el.find('.' + this.jsBlock + '__excavator-select-holder');
    this.dom.$excavatorSelect = this.dom.$el.find('.' + this.jsBlock + '__excavator-select');
    /*
    this.dom.$excavatorSelect.on('change', function () {
      var value = $(this).val();

      if(value === '-1') {
        //self._toggleResults(false);
      } else {
        //self._toggleResults(true);
        self._showResults([value]);
      }

      return;
    });*/
  }

  private _initMakeSelect() {
    var self = this;

    this.dom.$makeSelect = this.dom.$el.find('.' + this.jsBlock + '__make-select');

    this.dom.$makeSelect.on('change', function() {
      var $this = $(this),
          value = $this.val();

      self._updateExcavatorSelect(value, $this.data('target'));
      //self._toggleResults(false);
    });

    // Trigger once, so models update if there are any
    this.dom.$makeSelect.trigger('change');
  }

  public init() {
    var self = this;

    if(!this.dom.$el.length) {
      return;
    }

    this.excavatorsData = this.dom.$el.data('excavators');

    this._initExcavatorSelect();
    this._initMakeSelect();
  }
}

export { Questionnaire };
